<template>
  <div class="request-form">
    <div class="request-form-wrap">
      <div class="request-form-left">
        <div class="request-form-left-inner">
          <div class="request-form-left-spacer"></div>
            <img class="request-form-left-img" src="../assets/OneBookshelf-20.png"/>
          <div class="request-form-left-text">
            <h2>BookmarkSpanish</h2>
            <p>
              It's an online library with small 
              books and short stories written in spanish for beginners to 
              advanced learners
            </p>
            <p>
            Spend more time reading and less time looking up 
            words with our easy one click word translation. 
            </p>
            <h2 class="request-form-left-title-extra-space">What you get</h2>
            <ul>
              <li>Unlimited access to all stories.</li>
              <li>Spanish stories in level A1 to C2.</li>
              <li>Easy one click translation while reading.</li>
              <li>New stories added every month.</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="request-form-right">
        <div class="request-form-right-inner">
          <div class="request-form-right-top-wrap">
            <h1 class="request-form-right-title">
              Free account
            </h1>
            <div class="request-form-right-stroke"></div>
            <p class="request-form-right-sub">
              We are looking for people who will help us 
              improve our site by giving us feedback. 
              In return you will get unlimited access.
            </p>
            <p class="request-form-right-sub">
             Apply and tell us a little about your 
             journey with learning Spanish and what you think your current spanish level is.
            </p>
          </div>
          <div v-if="isSubmittet == false" class="request-form-input-wrap">
            <label for="name">Name</label>
            <input type="input" id="form-name" value="" placeholder="Please enter your name" v-model="formData.name">
            <label for="email">E-mail</label>
            <input type="input" id="form-name" value="" placeholder="Please enter your E-mail" v-model="formData.email">
            <label for="email">Your Spanish journey</label>
            <textarea class="request-form-comments" 
            placeholder="Please write a little about your spanish learning journey" 
            rows="5" cols="40" id="form-comment" name="comment" 
            v-model="formData.comments">
              Enter text here...
            </textarea>
            <button :disabled="submitPending" v-on:click="sendApplication" class="request-form-button">Apply</button>
          </div>
          <div v-if="isSubmittet" class="request-form-input-wrap">
            <h1>
              Got it, thanks!
            </h1>
            <p class="request-form-input-wrap-thanks">We are super happy for your interest and we are going to get back to you very soon!</p>
          </div>
        </div>
      </div>
    </div>
    <div class="request-form-footer-img-wrap">
      <img class="request-form-footer-img" src="../assets/footer-clouds.png"/>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase'

export default {
  name: 'RequestForm',
    data(){
    return {
      formData: {
        name: '',
        email: '',
        comments: ''
      },
      isSubmittet: false,
      submitPending: false
    }
  },
  methods: {
    sendApplication: function() {
      this.submitPending = true

      db.collection('leads').add({
        name: this.formData.name,
        email: this.formData.email,
        comments: this.formData.comments
      }).then(() => {
        this.isSubmittet = true
      });
    }
  }
}
</script>

<style scoped>
  .request-form-right-title, 
  .request-form-right-stroke,
  .request-form-right-sub {
    text-align: left;
  }
  .request-form-right-stroke {
    height: 4px;
    border-radius: 5px;
    width: 50px;
    background-color: #ed8887;
    margin-bottom: 20px;
    margin-left: 0px
  }
  .request-form-right h1,
  .request-form-right h4 {
    margin: 0;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  
  .equest-form-right-inner {
    text-align: left;

  }
  .request-form-input-wrap label{
    text-align: left;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .request-form-input-wrap input{
    height: 35px;
    border: 0px;
    background-color: #f0f0f0;
    margin-bottom: 20px;
    border-radius: 1px;
    padding-left: 15px;
  }
  .request-form-input-wrap input:focus {
    outline: none !important;
  }
  .request-form-input-wrap input::placeholder {
   color: #6f6f6f;
  }
  .request-form-input-wrap textarea {
    background-color: #f0f0f0;
    border: none;
    padding-left: 15px;
    padding-top: 10px;
    margin-bottom: 25px;
    border-radius: 1px;
  }
  .request-form-input-wrap textarea:focus {
    outline: none !important;
  }
  .request-form {
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
    min-height: calc(100vh - 75px);
  }
  .request-form-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 1000px;
  }
  .request-form-left,
  .request-form-right {
    z-index: 2;
    width: 100%;  
    max-width: 320px;
    margin: 0 auto;
  }
  .request-form-comments {
    resize: none;
  }
  .request-form-input-wrap {
    border-radius: 2px;
    box-shadow: -1px 2px 6px 2px rgba(0,0,0,0.04);
    justify-content: center;
    background-color: white;
    display: flex;
    flex-direction: column;
    padding: 15px;
    max-width: 280px;
    height: 345px;
    margin: 0 auto;
    margin-top: 50px;
  }

  .request-form-input-wrap-thanks {
    max-width: 210px;
    display: block;
    margin: 0 auto;
  }

  .request-form-button {
    background-color: #0161f6;
    color: white;
    height: 40px;
    border-style: none;
    border-radius: 2px;
    width: 100px;
    height: 35px;
    cursor: pointer;
  }

  .request-form-right-top-wrap {
    margin: 0 auto;
    max-width: 280px;
  }
  .request-form-footer-img-wrap {
    position: absolute;
    overflow: hidden;
    height: 200px;
    bottom: 0;
    width: 100%;
  }
  .request-form-left-img {
    width: 100%;
    max-width: 300px;
    filter: drop-shadow(4px 4px 2px rgba(0,0,0,0.15));
    opacity: 0.6;
  }
  .request-form-footer-img {
    object-fit: cover;
  }
  .request-form-left-inner, 
  .request-form-right-inner {
    margin-bottom: 50px;
  }
  .request-form-left-inner {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .request-form-left-text {
    max-width: 300px;
    margin-top: 20px;
    text-align: left;
  }
  .request-form-left-text li {
    margin-top: 10px;
  }

  .request-form-left-text ul {
    padding-inline-start: 20px;
  }

  .request-form-left-text h2 {
    margin-bottom: 10px;
  }

  .request-form-left-title-extra-space {
    margin-top: 35px;
  }
  .request-form-left-text-bold {
    font-weight: bold;
  }

  .request-form-left-spacer {
    height: 20px;
  }

  .request-form-left-text-get div{
    margin-top: 10px;
  }

  @media screen and (min-width: 1000px) { 
    .request-form-footer-img {
      width: 100%;
    }
  }

  @media screen and (min-width: 768px) { 
    .request-form-right-sub {
      max-width: 360px;
      margin-left: 10px;
    }
    .request-form-left-text {
      max-width: 350px;
    }

    .request-form-right-top-wrap {
      margin: 0;
      max-width: 100%;
    }
    .request-form-wrap {
      flex-direction: row;
    }
    .request-form-left,.request-form-right {
      width: 50%;  
      max-width: 600px;
    }
    .request-form-input-wrap { 
      margin: 0;
      margin-top: 30px;
      padding: 40px;
      max-width: 290px;
    }
    .request-form-left-inner, 
    .request-form-right-inner {
      margin-bottom: 30px;
      padding: 30px 50px 50px 50px;
    }
    .request-form-left-spacer {
      display: none;
    }
 
    .request-form-left-img {
      max-width: 350px;
    }

    .request-form-right-stroke,
    .request-form-right h1,
    .request-form-right h4 {
      margin-left: 10px;
    }
  }
</style>
